import { Inject, Injectable, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { IUser, IUserService, ResponseData } from './user-service.interface';
import { ENVIRONMENT_SERVICE_TOKEN, IEnvironmentService } from '../environment/environment-service.interface';

export const USER_SERVICE_TOKEN = new InjectionToken<IUserService>('IUserService');

@Injectable()
export class UserService implements IUserService {
  private url: string;

  constructor(@Inject(ENVIRONMENT_SERVICE_TOKEN) private environmentService: IEnvironmentService, private http: HttpClient) {
    this.url = this.environmentService.apiUrl;
  }

  data(): Observable<IUser> {
    return this.http.get(`${this.url}/account/user`).pipe(
      map((response: ResponseData) => {
        return response.data;
      })
    );
  }
}


